import { render, staticRenderFns } from "./dialogDefault.vue?vue&type=template&id=8ce16f9c"
import script from "./dialogDefault.vue?vue&type=script&lang=js"
export * from "./dialogDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports